import React, { FC } from 'react';
import { StyleSheet, Text } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  count: {
    position: 'absolute',
    bottom: 16,
    right: 16,
    fontFamily: 'Roboto-Bold',
  },
});

const PageCount: FC = () => (
  <Text style={styles.count} render={({ pageNumber }) => pageNumber} fixed />
);

export default PageCount;
